/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelclearevent2Inputs */

const en_channelclearevent2 = /** @type {(inputs: Channelclearevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const de_channelclearevent2 = /** @type {(inputs: Channelclearevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Channelclearevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelclearevent2 = /** @type {((inputs?: Channelclearevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelclearevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelclearevent2(inputs)
	return de_channelclearevent2(inputs)
});
export { channelclearevent2 as "channelClearEvent" }